'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;
exports.getSubject = getSubject;
exports.toggleSubject = toggleSubject;
exports.setErrorMessge = setErrorMessge;
exports.initSelectedSubjects = initSelectedSubjects;
exports.redirectToCUList = redirectToCUList;

var _reactRouter = require('react-router');

//获取短信验证码
var t = {
    GET_SUBJECT: '/subject/GET_SUBJECT',
    GET_SUBJECT_SUCCESS: '/subject/GET_SUBJECT_SUCCESS',
    GET_SUBJECT_FAIL: '/subject/GET_SUBJECT_FAIL',

    TOGGLE_SUBJECT: '/subject/TOGGLE_SUBJECT',
    SET_ERROR_MESSAGE: '/subject/SET_ERROR_MESSAGE',

    INIT_SELECTED_SUBJECTS: '/subject/INIT_SELECTED_SUBJECTS'
};

var NET_ERROR_MESSAGE = '网络繁忙，请稍后再试!';

var initialState = {
    // 科目列表
    subjects: [],
    // 用户选择的科目ID列表
    selectedSubjects: [],
    errorMessage: null
};

// Reducer
function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case t.GET_SUBJECT_SUCCESS:
            if (!action.result.data.success) {
                return _extends({}, state, {
                    errorMessage: action.result.data.info
                });
            } else {
                return _extends({}, state, {
                    subjects: action.result.data.data,
                    errorMessage: null
                });
            }
        case t.TOGGLE_SUBJECT:
            {
                var res = _extends({}, state, {
                    errorMessage: null
                });
                var i = res.selectedSubjects.map(function (s) {
                    return s.id;
                }).indexOf(action.subject.id);
                if (i > -1) {
                    res.selectedSubjects.splice(i, 1);
                } else if (res.selectedSubjects.length < 3) {
                    res.selectedSubjects.push(action.subject);
                } else if (res.selectedSubjects.length >= 3) {
                    res.errorMessage = '只能选三项';
                }
                return res;
            }
        case t.SET_ERROR_MESSAGE:
            return _extends({}, state, {
                errorMessage: action.errorMessage
            });
        case t.INIT_SELECTED_SUBJECTS:
            return _extends({}, state, {
                selectedSubjects: []
            });
        default:
            return state;
    }
}

// Actions
function getSubject() {
    return {
        types: [t.GET_SUBJECT, t.GET_SUBJECT_SUCCESS, t.GET_SUBJECT_FAIL],
        promise: function () {
            function promise(client) {
                return client.get('/api/subject');
            }

            return promise;
        }()
    };
}

function toggleSubject(subject) {
    return {
        type: t.TOGGLE_SUBJECT,
        subject: subject
    };
}

function setErrorMessge(errorMessage) {
    return {
        type: t.SET_ERROR_MESSAGE,
        errorMessage: errorMessage
    };
}

function initSelectedSubjects() {
    return {
        type: t.INIT_SELECTED_SUBJECTS
    };
}

function redirectToCUList() {
    return function (dispatch, getState) {
        var selectedSubjects = getState().subject.selectedSubjects;

        if (selectedSubjects.length == 0) {
            dispatch(setErrorMessge('您还没有选择科目'));
            return;
        }
        var querySelectedSubjects = [];
        selectedSubjects.map(function (item, index) {
            querySelectedSubjects.push(JSON.stringify(item));
        });
        _reactRouter.browserHistory.push({
            pathname: '/subject/culist',
            query: {
                selectedSubjects: querySelectedSubjects
            }
        });
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/reducers/subject/subject.js
// module id = 389
// module chunks = 0